import { NgModule } from '@angular/core';
import { BillingIvoiceItemManualDialogComponent } from '../dialogs/billing-ivoice-item-manual-dialog/billing-ivoice-item-manual-dialog.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { SharedMaterialModule } from '../shared-material.module';

@NgModule({
    declarations: [
      BillingIvoiceItemManualDialogComponent,
    ],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      SharedModule,
      SharedMaterialModule
    ], exports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        SharedMaterialModule
    ],
    entryComponents: [
      BillingIvoiceItemManualDialogComponent
    ]
  })
  export class BillingInvoiceManualSharedModule { }
